/**
 * Format company name for display by removing trailing legal-entity suffixes
 * (e.g. "/DE/", "/MD/") commonly present in SEC filing data.
 */
export function formatCompanyName(raw: string | null | undefined): string {
  if (raw == null || typeof raw !== 'string') return '';
  let s = raw.trim();
  // Remove trailing "/STATE/" style suffixes (e.g. /DE/, /MD/, /CA/)
  s = s.replace(/\s*\/[A-Z]{2,3}\/?\s*$/i, '').trim();
  return s || raw.trim();
}
